import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { isUWP } from '../../../utilities';
import { isAgaveSelector } from '../../app/selectors/contactUsSelector';
import { BackgroundAuth } from '../presentationalComponents/BackgroundAuth';
import { dispatchFetchBackgroundAuthUri, dispatchGetInfoForClientTokenRetrieval } from '../reduxUpdater/dispatchers/contactUsDispatchers';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
    return {
        backgroundAuthUri: state.ContactState.ModalitySectionState.backgroundAuthUri,
        isUWP: isUWP(state.GlobalState.namespace),
        isAgave: isAgaveSelector(state),
    };
};
const mapDispatchToProps = {
    dispatchFetchBackgroundAuthUri,
    dispatchGetInfoForClientTokenRetrieval,
};

export const BackgroundAuthContainer = connect(mapStateToProps, mapDispatchToProps)(BackgroundAuth);
